/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import AppConstants from "../appConstants";


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const userDefaults = {
  // uid         : 0,          // From Auth
  // displayName : "John Doe", // From Auth
  // about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  // photoURL    : require("@/assets/images/portrait/small/avatar-s-11.png"), // From Auth
  // status      : "online",
  // userRole    : "admin",
  agency: [],
  userCode: 0,
  token: '',
  email: '',
  originCode: 250,
  hasQuotesRights: false,
  nome: '',
  rights: [],
  s4Login: false,
  skipTour: false,
  afterLoginShowBiometry: true,
  theme: 'light',
  viewstyle: 1,
  rateTextSpeech: 1.0,
  zoom: AppConstants.ZOOM.DEFAULT,
  zoomDetail: AppConstants.ZOOM.DEFAULT,
  formatAlignDetail: AppConstants.DETAIL_FORMAT_ALIGN.CENTER,
  profile: 0
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  displaySystem: true,
  AppActiveUser: userDefaults,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  theme: themeConfig.theme || "light",
  biometry: false,
  themePrimaryColor: colors.primary,
  agency: null,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  isProduction: false,
  isDesktop: true,
  reportViewStyle: AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED,
  highlightCollapsed: false,

  displaySubscribeTools: true,
  displayAuthorDetail: true,
  displayNavMenu: true,
  isAuthenticated: false,
  locale: 1,

  // favorite contens
  favoriteContent: [],
  currentFilter: {},

  // INFORMATIVE
  currentCommodity: { id: null },
  currentContent: AppConstants.INFORMATIVE_FILTER_ALL_OPTION,
  currentReportType: { id: null },

  // textSpeech
  textSpeechIsPaused: false,
  textSpeechIsPlaying: false,

  subjectsMenu: [],


  playlistOpen: false,
  playlist: [],
  playlistItemSelected: null,
  currentMedia: null,
  currentMediaData: {
    youtubePlayer: { isPlaying: false, currentTime: 0 },
    audioPlayer: { isPlaying: false, currentTime: 0 },
  },

  latestMedia: [],

  contentPrivate: null,
  quotesPublic: null,

  filterUsers: [],

  refreshActive: false,
  contentSubmenuReduceSidebar: false,

  isMobileIOS: false,

  notifications: [],
  scheduleData: [],

  // Tickers

  tickerViewAtTheTop: true,
  canDisplayTicker: true,
  viewImportantTickers: true,
  viewHighlightsTickers: true,

  quotesContentList: [],

  hasBiometry: false,
  biometryType: '',
  biometrySecrets: '',
  biometrySecretsStatus: '',
  isBiometryAvailable: false,
  onLogin: false,
  correlationId: '',
  insetTop: 0,
  insetBottom: 0,
  insetLeft: 0,
  insetRight: 0,
};

export default state
